import React, { useState } from 'react';
import {useOutletContext} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";

function VisibilityToggle({ isVisible, branchID, disabled }) {
    const [onOpenQrAfterGenerate, onCloseQrReset] = useOutletContext();
    const dispatch = useDispatch();
    const handleToggleChange = (event) => {
        const payload = {
            BranchID: branchID,
            isVisible: event.target.checked
        }

        dispatch(setActionType(ACTION_TYPES.HIDE_BRANCH));
        dispatch(setActionPayload(payload));

        onOpenQrAfterGenerate();
    };

    return (
        <div className="toggle-switch">
            <input
                id="toggle"
                className="toggle-input"
                checked={isVisible}
                type="checkbox"
                onChange={handleToggleChange}
                disabled={disabled}
            />
            <label htmlFor="toggle" className="toggle-label" />
        </div>
    );
}

export default VisibilityToggle;
